import Index from "../..";

// Alias to / landing page
export default Index;
